//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { NsExpressiveLink } from "@nuskin/design-components";
import { NsIcon } from "@nuskin/ns-icon";
import NsLightbox from "./NsLightbox.vue";
import NsImage from "./NsImage.vue";
export default {
  name: "NsInformationCard",
  components: { NsExpressiveLink, NsLightbox, NsImage, NsIcon },
  props: {
    /**
     * The content text
     */
    contentText: {
      type: String,
      default: ""
    },
    /**
     * The image fit
     * @values cover, contain
     */
    imageFit: {
      type: String,
      default: "cover",
      validator: value => ["cover", "contain"].includes(value)
    },
    /**
     * The image url
     */
    imageUrl: {
      type: String,
      default: ""
    },
    /**
     * The link's label
     */
    linkText: {
      type: String,
      default: ""
    },
    /**
     * The url the link will take you to
     */
    linkUrl: {
      type: String,
      default: ""
    },
    /**
     * The title label
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * The video source url
     */
    videoSrc: {
      type: String,
      default: ""
    },
    /**
     * Source tags can be used instead of ctaUrl
     */
    videoSrcTags: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    lightboxOpen: false
  }),
  computed: {
    phabletAndDown() {
      return this.$mq === "phablet" || this.$mq === "mobile";
    },
    isVideo() {
      const vidExt = ["mov", "avi", "wmv", "flv", "3gp", "mp4", "mpg", "webm"];
      return vidExt.some(ext => this.videoSrc.endsWith(`.${ext}`));
    }
  },
  methods: {
    /**
     * Closes lightbox
     */
    handleCloseLightbox() {
      this.lightboxOpen = false;
    },
    handleOpenLightbox() {
      this.lightboxOpen = true;
    }
  }
};
